<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Danh mục</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col>
                                <b-form-group label="Danh mục:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <!--<b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>-->
                                    <treeselect class="col-6 no-padding" id="categoryId"
                                                v-if="categories.length > 0"
                                                v-model="searchForm.categoryId"
                                                placeholder="--- Chọn ---"
                                                :options="categories" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Từ khóa:"
                                              label-for="input-name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-input type="text" class="col-6" id="input-name" v-model="searchForm.str" placeholder="Nhập tên hoặc mã ..."></b-form-input>
                                    
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            selectable
                            dataUrl="master-data/categories"
                            gridName="Danh sách danh mục"
                            ref="categoryTable">
                        <template v-slot:actions>
                            <router-link v-if="authorize(['ManageCategory'])" to="/master-data/categories/create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <b-button size="md" @click.stop="deletes" variant="danger" :disabled="isDisabledDelete">
                                Xóa
                            </b-button>
                        </template>
                        <template v-slot:cell(status)="row">
                            <b-form-checkbox v-model="row.value" disabled @change="updateStatus(row.item, $event)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(isShowHome)="row">
                            <b-form-checkbox v-model="row.value" disabled @change="updateStatus(row.item, $event)"></b-form-checkbox>
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewCategory'])" size="sm" :to="{ path: `./detail/${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <template>
                                    <b-button v-if="authorize(['ManageCategory'])" size="sm" :to="{ path: `./edit/${row.item.id}` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button v-if="authorize(['ManageCategory'])" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { authorizationMixin } from '@/shared/mixins'

    export default {
        name: 'ListUnitType',
        mixins: [authorizationMixin],
        data() {
            return {
                searchForm: {
                    str: null,
                    categoryId: null
                },
                isDisabledDelete: true,
                gridOptions: {
                    fields: [
                        { key: 'parentName', label: 'Danh mục cha', sortable: true, sortDirection: 'asc' },
                        { key: 'name', label: 'Tên danh mục', sortable: true, sortDirection: 'asc' },
                        { key: 'slug', label: 'Tên không dấu', sortable: true, sortDirection: 'asc' },
                        // { key: 'urlImage', label: 'Hình ảnh', sortable: true, sortDirection: 'asc' },
                        { key: 'title', label: 'Tiêu đề', sortable: true, sortDirection: 'asc' },
                        { key: 'description', label: 'Mô tả', sortable: true, sortDirection: 'asc' },
                       
                        { key: 'status', label: 'Trạng thái', sortable: false },
                        { key: "isShowHome", label: "Hiển thị trên trang chủ", sortable: false },

                    ],
                    sortBy: 'id'
                },
            }
        },
        computed: {
            ...mapState({
                categories: (state, getters) => getters.categoryTree,
            })
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.categoryTable.selectedRows
                },
                (val) => {
                    this.isDisabledDelete = val.length == 0;
                }
            )
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.categoryTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;

                if (confirm('Bạn có chắc chắn muốn xóa danh mục này?')) {
                    this.$services.delete(`master-data/categories/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa danh mục thành công');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.categoryTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các danh mục này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/categories?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa danh mục thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn danh mục cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
</style>
